// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1rmC0","footer":"Form_footer__dhQad"};